<template>
  <section class="tw-flex-1 tw-flex tw-flex-col">
    <CommonHeader />
    <ClientOnly>
      <KycDev v-if="enableDevTools" />
      <Kyc v-else />
    </ClientOnly>
  </section>
</template>
<script setup lang="ts">
  const {
    public: { enableDevTools },
  } = useRuntimeConfig()


  useHead({
    script: [
      {
        src: 'https://asset.legendtrading.com/_upload/libs/google/google-autocomplete.min.js?v=1',
        async: true,
      },
    ],
  })

  definePageMeta({
    middleware: ['ip2location'],
  })
</script>
